import React from "react";
import {Bar, BarChart, CartesianGrid, Cell, LabelList, ResponsiveContainer, XAxis, YAxis} from "recharts";
import {formatMenge} from "../format.js";

/**
 * Balken "Wie viel bestellen?" (Folie 6, Auftrag S7): Mindestbestand M,
 * Zielbestand Z und Bestellmenge Q des gerade gewählten Beispiel-Farbtons -
 * live aus derselben Prognose wie das Artikel-Blatt, keine erfundenen Zahlen.
 * Die Lagerkapazität erscheint als vierter Balken, wenn sie gepflegt ist -
 * sie ist die Obergrenze, an der Q laut UMSETZUNG.md D7 gekappt wird.
 */
export default function BestellmengeSchaubild({prognose, lagerkapazitaetStueck, paletteStueck}) {
    if (!prognose || prognose.status !== "gerechnet") {
        return <div className="text-muted small">Für diesen Farbton liegt keine Prognose vor.</div>;
    }

    const mindestbestand = prognose.mindestbestand?.wert ?? null;
    const zielbestand = prognose.zielbestand?.wert ?? null;
    const bestellmenge = prognose.szenarien?.erwartet?.bestellmenge?.wert ?? null;

    const zeilen = [
        {name: "Mindestbestand M", wert: mindestbestand, farbe: "#7c4a03"},
        {name: "Zielbestand Z", wert: zielbestand, farbe: "#1b4d24"},
        lagerkapazitaetStueck ? {name: "Lagerkapazität", wert: lagerkapazitaetStueck, farbe: "#868e96"} : null,
        {name: "Bestellmenge Q", wert: bestellmenge, farbe: "#a3d900"},
    ].filter((z) => z && z.wert !== null && z.wert !== undefined);

    if (zeilen.length === 0) {
        return <div className="text-muted small">Für diesen Farbton liegen noch keine Kennzahlen vor.</div>;
    }

    return (
        <div>
            <ResponsiveContainer width="100%" height={240}>
                <BarChart data={zeilen} layout="vertical" margin={{top: 8, right: 60, left: 8, bottom: 8}}>
                    <CartesianGrid strokeDasharray="3 3" horizontal={false} stroke="#e9ecef" />
                    <XAxis type="number" tickFormatter={formatMenge} tick={{fontSize: 11}} />
                    <YAxis type="category" dataKey="name" tick={{fontSize: 12}} width={140} axisLine={false} tickLine={false} />
                    <Bar dataKey="wert" radius={[0, 4, 4, 0]} barSize={28} isAnimationActive={false}>
                        {zeilen.map((z) => (
                            <Cell key={z.name} fill={z.farbe} />
                        ))}
                        <LabelList
                            dataKey="wert"
                            position="right"
                            formatter={(wert) => `${formatMenge(wert)} Dosen${paletteStueck ? ` (${formatMenge(wert / paletteStueck)} Pal.)` : ""}`}
                            style={{fontSize: 12, fill: "#212529"}}
                        />
                    </Bar>
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
}
